try {
            if (process.env.TOKENS_FEATURE_FLAG === 'true') require('./index-new.css');
            else require('./index.css');
          } catch (e) {
            if (e.code !== 'MODULE_NOT_FOUND') {
              throw e; // Re-throw unexpected errors
            }
            console.warn('index.css not found, proceeding without it.');
          }
          

import { jsx } from 'react/jsx-runtime';
import { Link } from '@design-system/link';
import { forwardRef } from 'react';
import classNames from 'classnames';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

const getClassName = ({ align, variant, wrapping, className, size, weight, }) => {
    const isBodyOrHeadlineOrDetail = variant === 'body' || variant === 'headline' || variant === 'detail';
    return classNames('cds-typography', className, {
        [`cds-typography--align-${align}`]: align,
        [`cds-typography--variant-${variant}`]: variant,
        [`cds-typography--variant-${variant}-${size}`]: isBodyOrHeadlineOrDetail && size,
        [`cds-typography--wrapping-${wrapping}`]: wrapping,
        [`cds-typography--weight-${weight}`]: isBodyOrHeadlineOrDetail && weight,
    });
};

const unwrapFirstTag = (typographyTag, typographyVariant, typographyContent) => {
    const openTagRegExp = /^<\/?[^>]+(>|$)/g;
    const closeTagRegExp = /<\/[^>]+(>$)/g;
    return typographyVariant !== 'rte' && typographyTag !== 'div'
        ? typographyContent
            .toString()
            .replace(openTagRegExp, '')
            .replace(closeTagRegExp, '')
        : typographyContent;
};

const Typography = forwardRef((_a, ref) => {
    var { content, tag = 'div', variant, align, className, size = 'm', weight = 'regular', wrapping = 'break-word', link } = _a, htmlProperties = __rest(_a, ["content", "tag", "variant", "align", "className", "size", "weight", "wrapping", "link"]);
    const LinkElement = (link === null || link === void 0 ? void 0 : link.component) || Link;
    const typographyClassName = getClassName({
        align,
        variant,
        wrapping,
        className,
        size,
        weight,
    });
    const Tag = tag && variant !== 'rte' ? tag : 'div';
    const html = unwrapFirstTag(tag, variant, content);
    return link ? (jsx(Tag, Object.assign({ className: typographyClassName, ref: ref }, htmlProperties, { children: jsx(LinkElement, Object.assign({}, link.props, { iconPrefix: undefined, iconSuffix: undefined }, { children: jsx("span", { dangerouslySetInnerHTML: { __html: html } }) })) }))) : (jsx(Tag, Object.assign({ className: typographyClassName, ref: ref, dangerouslySetInnerHTML: { __html: html } }, htmlProperties)));
});

export { Typography };
